import React from 'react';
var FlagIcon = function (_a) {
    var country = _a.country;
    return (React.createElement("div", { className: "phoneInputCountryWrapper" },
        React.createElement("div", { className: "PhoneInputCountryIcon" },
            React.createElement("img", { className: "PhoneInputCountryIconImg", alt: country, src: "https://catamphetamine.github.io/country-flag-icons/3x2/".concat(country, ".svg") })),
        React.createElement("div", { className: "PhoneInputCountrySelectArrow" })));
};
export default FlagIcon;
//# sourceMappingURL=FlagIcon.js.map